import React from 'react';

import { faArrowRightLong } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { styled } from 'styled-components';

import MenuItemSubHeader from 'components/Layout/Header/components/MegaMenuItem/components/MegaMenuItemBody/components/MenuItemSubHeader';
import Link from 'components/Link';

import { MenuColumnSubMenuItemI } from 'interfaces/content-stack/contentStack.types';

import { autoOptimizeImage } from 'utils/functions';
import { getModularBlockLink } from 'utils/modularBlockUtils';

const MegaMenuImageCardWrapper = styled.div`
  display: flex;
  height: 100%;
  min-width: 15rem;
  max-width: 15rem;
  background-color: ${(props) => props.theme.colors.backgroundLightGray};
  flex-direction: column;
  align-content: start;
  font-size: 0.875rem;
  text-decoration: none;
  overflow: hidden;
  margin-right: 2rem;
`;

const Image = styled.img`
  width: 100%;
  height: 9rem;
  object-fit: cover;
`;

const CallToAction = styled.div`
  padding: 1rem 1rem 1rem;
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
`;

const CtaLink = styled(Link)`
  text-decoration: none;
  color: ${(props) => props.theme.colors.black};
  font-size: 0.875rem;
  font-weight: 700;
  cursor: pointer;
  padding-bottom: 0.15rem;
  width: fit-content;

  &:hover {
    border-bottom: solid 0.0625rem ${(props) => props.theme.colors.primaryRed};
  }

  & svg {
    margin-left: 0.25rem;
  }
`;

const ImageCardHeader = styled.div`
  font-size: 1rem;
  font-weight: 600;
  text-decoration: none;
  margin-bottom: 0.25rem;
`;

const CopyContainer = styled.div`
  margin-bottom: 0.5rem;
`;

interface MegaMenuImageCardProps {
  data: MenuColumnSubMenuItemI;
}

const MegaMenuImageCard: React.FC<MegaMenuImageCardProps> = ({ data }) => {
  const { imageAsset, linkText, snippet, ctaButton } = data;
  const linkUrl = getModularBlockLink(ctaButton?.buttonLink);

  return (
    <MegaMenuImageCardWrapper>
      <Image
        src={autoOptimizeImage(imageAsset?.imageAsset?.url, true, '300')}
        alt={imageAsset?.altImageText || 'Image'}
        loading='lazy'
      />
      <CallToAction>
        <CopyContainer>
          {linkText && <ImageCardHeader>{linkText}</ImageCardHeader>}
          {snippet && <MenuItemSubHeader richText={snippet} />}
        </CopyContainer>
        <CtaLink to={linkUrl} data-testid='desktop-navbar-item'>
          {ctaButton?.buttonText}
          <FontAwesomeIcon icon={faArrowRightLong} />
        </CtaLink>
      </CallToAction>
    </MegaMenuImageCardWrapper>
  );
};

export default MegaMenuImageCard;
